import type { OfficeClockRequest } from '@/entities/office-time'

const LOCATION_WAIT_MS = 1_000
const LOCATION_MAX_AGE_MS = 5 * 60_000

let locationRefused = false

const nothing = (): Promise<OfficeClockRequest> => Promise.resolve({})

export function readOfficeLocation(): Promise<OfficeClockRequest> {
  if (locationRefused || typeof navigator === 'undefined' || !navigator.geolocation) return nothing()

  return new Promise((resolve) => {
    const giveUp = window.setTimeout(() => resolve({}), LOCATION_WAIT_MS)
    navigator.geolocation.getCurrentPosition(
      (position) => {
        window.clearTimeout(giveUp)
        resolve({ lat: position.coords.latitude, lng: position.coords.longitude })
      },
      (failure) => {
        window.clearTimeout(giveUp)
        if (failure.code === failure.PERMISSION_DENIED) locationRefused = true
        resolve({})
      },
      { enableHighAccuracy: false, timeout: LOCATION_WAIT_MS, maximumAge: LOCATION_MAX_AGE_MS },
    )
  })
}
